import React from 'react'
import A2zwork from "../images/banner.jpg"
import A2zworkservicehome from "../images/Home page banner.png"
import A2ZINDIAs from "../images/A2ZINDIA.jpg"
function Slider() {
  return (
    <div>
      <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-indicators">
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
  
  </div>
  <div className="carousel-inner">
    <div className="carousel-item active">
      <div className='radiusp'>
      <img src={A2zworkservicehome} className="d-block w-100" alt="A2Z Service Work"/>
    </div>
    </div>
    <div className="carousel-item">
    <div className='radiusp'>
      <img src={A2zwork} className="d-block w-100" alt=" A2zworkservice"/>
    </div>
    </div>
    <div className="carousel-item">
    <div className='radiusp'>
      <img src={A2ZINDIAs} className="d-block w-100" alt="BestInterior"/>
    </div>
   </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
    </div>
  )
}

export default Slider
